module.exports = __webpack_public_path__ + "static/img/iphone_room_title3.d0e0f3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/iphone_room_title3.png
// module id = NQca
// module chunks = 0